module.exports = __webpack_public_path__ + "static/media/stato-fallimento.bb9656bf.odt";